<template>
  <form novalidate="true" @submit.prevent="submit">
    <b-field
      label="Numéro*"
      :message="fields.number.error"
      :type="fields.number.error !== null ? 'is-danger' : ''"
    >
      <b-input v-model="fields.number.value" type="text" />
    </b-field>
    <b-field
      label="ESN*"
      :message="fields.serialNumber.error"
      :type="fields.serialNumber.error !== null ? 'is-danger' : ''"
    >
      <b-input v-model="fields.serialNumber.value" type="text" />
    </b-field>
    <b-field
      label="Auth*"
      :message="fields.authorizationCode.error"
      :type="fields.authorizationCode.error !== null ? 'is-danger' : ''"
    >
      <b-input v-model="fields.authorizationCode.value" type="text" />
    </b-field>
    <b-field
      label="Date d'achat*"
      :message="fields.purchasedAt.error"
      :type="fields.purchasedAt.error !== null ? 'is-danger' : ''"
    >
      <b-datepicker
        v-model="fields.purchasedAt.value"
        placeholder="Type or select a date..."
        icon="calendar-day"
        :date-formatter="dateFormat"
      />
    </b-field>
    <b-field
      label="Propriétaire*"
      :message="fields.owner.error"
      :type="fields.owner.error !== null ? 'is-danger' : ''"
    >
      <b-select v-model="fields.owner.value" label="Choisir un propriétaire" expanded>
        <option v-for="owner in owners" :key="owner" :value="owner">
          {{ capitalize(owner) }}
        </option>
      </b-select>
    </b-field>
    <b-field
      label="Modèle*"
      :message="fields.model.error"
      :type="fields.model.error !== null ? 'is-danger' : ''"
    >
      <b-select v-model="fields.model.value" expanded>
        <option value="" disabled>Choisir un modèle</option>
        <option v-for="model in Object.keys(spotModels)" :key="model" :value="model">
          {{ spotModels[model] }}
        </option>
      </b-select>
    </b-field>
    <b-field
      label="Usure"
      :message="fields.wear.error"
      :type="fields.wear.error !== null ? 'is-danger' : ''"
    >
      <b-select v-model="fields.wear.value" expanded>
        <option v-for="wear in wears" :key="wear.value" :value="wear.value">
          {{ wear.label }}
        </option>
      </b-select>
    </b-field>
    <b-field
      label="Commentaire"
      :message="fields.comment.error"
      :type="fields.comment.error !== null ? 'is-danger' : ''"
    >
      <b-input v-model="fields.comment.value" type="textarea" />
    </b-field>
    <hr />
    <b-field>
      <b-button
        native-type="submit"
        type="is-primary"
        :loading="loading"
        :disabled="loading || isInvalid"
      >
        Ajouter
      </b-button>
    </b-field>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { format } from 'date-fns'
import { OWNERS } from '@constants/tracker/owner'
import { SPOT_MODELS } from '@constants/tracker/model'
import { WEARS } from '@constants/tracker/wear'
import { capitalize } from '@helpers/capitalize'

export default {
  name: 'AddSpotTrackerForm',

  data() {
    return {
      loading: false,
      fields: {
        number: {
          value: '',
          error: null,
        },
        serialNumber: {
          value: '',
          error: null,
        },
        authorizationCode: {
          value: '',
          error: null,
        },
        purchasedAt: {
          value: null,
          error: null,
        },
        owner: {
          value: '',
          error: null,
        },
        model: {
          value: '',
          error: null,
        },
        wear: {
          value: 0,
          error: null,
        },
        comment: {
          value: '',
          error: null,
        },
      },
    }
  },

  watch: {
    'fields.authorizationCode.value'(authorizationCode) {
      this.fields.authorizationCode.error =
        authorizationCode && authorizationCode.length !== 8
          ? 'Le code Auth doit faire 8 caractères'
          : null
    },
  },

  created() {
    this.owners = OWNERS
    this.spotModels = SPOT_MODELS
    this.wears = WEARS
  },

  computed: {
    isInvalid() {
      return (
        !this.fields.number.value ||
        !this.fields.serialNumber.value ||
        (this.fields.authorizationCode.value || '').length !== 8 ||
        !this.fields.purchasedAt.value ||
        !this.fields.owner.value ||
        !this.fields.model.value
      )
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit() {
      this.loading = true

      try {
        const spotTracker = await this.$services.spotTrackerService.create({
          number: this.fields.number.value,
          serialNumber: this.fields.serialNumber.value,
          authorizationCode: this.fields.authorizationCode.value,
          purchasedAt: this.fields.purchasedAt.value,
          comment: this.fields.comment.value,
          owner: this.fields.owner.value.toLowerCase(),
          model: this.fields.model.value,
          wear: this.fields.wear.value,
        })
        this.addToastMessage({
          text: `Le tracker Spot ${spotTracker.number} a été ajouté.`,
          type: 'is-success',
        })
        this.$router.push({
          name: 'spotTracker.edit',
          params: { id: spotTracker.id },
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ?? 'La création du tracker Spot a échouée.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },

    dateFormat(date) {
      return format(date, 'dd/MM/yyyy')
    },

    capitalize(value) {
      return capitalize(value)
    },
  },
}
</script>
